var map = {
	"./avatars/default": 29,
	"./avatars/default.png": 29,
	"./avatars/null_female": 30,
	"./avatars/null_female.png": 30,
	"./avatars/null_male": 31,
	"./avatars/null_male.png": 31,
	"./banners/MyMP-Banner": 32,
	"./banners/MyMP-Banner.png": 32,
	"./banners/nft_banner": 33,
	"./banners/nft_banner.png": 33,
	"./blog/01": 34,
	"./blog/01.jpg": 34,
	"./blog/02": 35,
	"./blog/02.jpg": 35,
	"./icons/eye": 36,
	"./icons/eye.svg": 36,
	"./icons/like": 37,
	"./icons/like-2": 38,
	"./icons/like-2.svg": 38,
	"./icons/like.svg": 37,
	"./icons/search": 39,
	"./icons/search.svg": 39,
	"./logo": 40,
	"./logo.png": 40,
	"./masks/avatar-group": 41,
	"./masks/avatar-group-hover": 42,
	"./masks/avatar-group-hover-last": 43,
	"./masks/avatar-group-hover-last.svg": 43,
	"./masks/avatar-group-hover.svg": 42,
	"./masks/avatar-group.svg": 41,
	"./masks/avatar-status": 44,
	"./masks/avatar-status.svg": 44,
	"./masks/icon-status": 45,
	"./masks/icon-status.svg": 45,
	"./mymp-icon": 46,
	"./mymp-icon.svg": 46,
	"./mymp-logo": 47,
	"./mymp-logo-dark": 48,
	"./mymp-logo-dark.svg": 48,
	"./mymp-logo-light": 49,
	"./mymp-logo-light.svg": 49,
	"./mymp-logo.svg": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;